// src/constants.js

// export const API_BASE_URL = "http://localhost:9002/cred"
export const API_BASE_URL = "https://koelsmartenergy.com/cred"
export const ROLES = {
  ADMIN: "Admin",
  USER: "User",
  SUPER_ADMIN: "Super-Admin",
};
